const $=($,o)=>o?`${$}--${o}`:"",o=($,o,t)=>t?`${$}--${o}`:"";export{$ as classNameModifier,o as classNameModifierByFlag};
